(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["envol-catalogue"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-envol-card]').forEach((card) => {
    const frames = [...card.querySelectorAll('[data-envol-frame]')];
    const dots = [...card.querySelectorAll('[data-envol-dot]')];
    if (frames.length < 2) return;
    let index = 0;
    let timer;
    const show = (next) => {
      index = next % frames.length;
      frames.forEach((frame, i) => frame.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    const start = () => { if (matchMedia('(hover: hover)').matches) timer = setInterval(() => show(index + 1), 1150); };
    const stop = () => { clearInterval(timer); show(0); };
    card.addEventListener('pointerenter', start);
    card.addEventListener('pointerleave', stop);
    dots.forEach((dot) => dot.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); clearInterval(timer); show(Number(dot.dataset.envolDot)); }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["envol-future-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('envol-hero-slideshow')) {
  customElements.define('envol-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.envol-hero-slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.pauseButton = this.querySelector('[data-pause]');
      if (this.slides.length < 2 || !this.pauseButton) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.updatePause();
      this.dots.forEach(button => button.addEventListener('click', () => {
        this.show(Number(button.dataset.slide));
        this.start();
      }));
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.start();
      });
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => clearInterval(this.timer));
      this.addEventListener('focusout', () => this.start());
      this.visibility = () => this.start();
      document.addEventListener('visibilitychange', this.visibility);
      this.motionChange = () => { this.paused = this.motion.matches; this.updatePause(); this.start(); };
      this.motion.addEventListener('change', this.motionChange);
      this.start();
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      this.dots.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    updatePause() {
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Lancer le diaporama' : 'Mettre le diaporama en pause');
    }
    start() {
      clearInterval(this.timer);
      if (!this.paused && !document.hidden) this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), 6000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.visibility);
      this.motion?.removeEventListener('change', this.motionChange);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["envol-info-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let frame = 0;
    const updateStandardCards = () => {
      document.querySelectorAll('main .rich-text__blocks, main .image-with-text__content, main .multicolumn-list').forEach((card) => {
        if (card.closest('.multirow')) return;
        if (card.querySelector('a[href^="http"]')) {
          card.style.transform = 'none';
          card.style.opacity = '1';
          card.style.filter = 'none';
          return;
        }
        const rect = card.getBoundingClientRect();
        const viewportCenter = window.innerHeight / 2;
        const cardCenter = rect.top + rect.height / 2;
        const signedDistance = (cardCenter - viewportCenter) / Math.max(window.innerHeight * .78, 1);
        const distance = Math.min(Math.abs(signedDistance), 1);
        const focus = 1 - distance;
        const scale = .94 + focus * .065;
        const depth = -120 + focus * 150;
        const offset = signedDistance * 30;
        card.style.transform = `translate3d(0, ${offset}px, ${depth}px) scale(${scale})`;
        card.style.opacity = .86 + focus * .14;
        card.style.filter = 'none';
      });
    };
    const updateCancerCards = () => {
      frame = 0;
      const viewportCenter = window.innerHeight / 2;
      if (document.querySelector('.envol-info-style--cancer')) document.querySelectorAll('main .multirow .image-with-text__grid').forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.top + rect.height / 2;
        const signedDistance = (cardCenter - viewportCenter) / Math.max(window.innerHeight * .72, 1);
        const distance = Math.min(Math.abs(signedDistance), 1);
        const focus = 1 - distance;
        const scale = .92 + focus * .095;
        const depth = -170 + focus * 215;
        const offset = signedDistance * 42;
        const opacity = .82 + focus * .18;
        card.style.transform = `translate3d(0, ${offset}px, ${depth}px) scale(${scale})`;
        card.style.opacity = opacity;
        card.style.filter = 'none';
        card.style.boxShadow = focus > .72 ? `0 26px 70px rgba(0,0,0,.42), 0 0 ${Math.round(focus * 24)}px rgba(242,19,103,.11)` : '';
      });
      updateStandardCards();
    };
    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(updateCancerCards);
    };
    const start = () => {
      updateCancerCards();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if(!customElements.get('es-purchase-bar')){
customElements.define('es-purchase-bar',class extends HTMLElement{
 connectedCallback(){
 this.abort=new AbortController();this.update=()=>{const root=this.closest('product-info'),submit=root?.querySelector('.product-form__submit'),price=root?.querySelector('[id^="price-"] .price-item--regular');if(!submit)return;this.hidden=!(scrollY>180&&submit.getBoundingClientRect().bottom<0);const b=this.querySelector('button');b.disabled=submit.disabled||submit.getAttribute('aria-disabled')==='true';b.textContent=submit.querySelector('span')?.textContent.trim()||submit.textContent.trim();if(price)this.querySelector('[data-es-sticky-price]').textContent=price.textContent.trim()};
 window.addEventListener('scroll',this.update,{passive:true,signal:this.abort.signal});this.observer=new MutationObserver(this.update);this.observer.observe(this.closest('product-info').querySelector('.product__info-container'),{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
});
}

  } catch(e) { console.error(e); }
})();
})();
